import { envs } from '@/config/envs'

export const isOverviewType = (): boolean => envs().APP.TYPE === 'overview'
